import React from "react";
import theme from '../../../../config/theme';

import FormUnit from "../../../elements/Form/FormUnit";

const CategoryFilterBlock = (props) => {
    const handleChange = (id, key) => {
        props.onChange({
            id: id,
            value: key,
            checked: true
        });
    }

    let isAllProducts = true;

    for(let i in props.options) {
        if(props.options[i].status) {
            isAllProducts = false;
        }
    }

    return (<>
        <style jsx>{`
            .category {
                padding: 2px 5px;
                border-radius: 5px;
                margin-bottom: 5px;
                cursor: pointer;
                color: ${theme.colors.base.base};
                text-transform: uppercase;
            }

            .category.primary-category {
                font-weight: 700;
            }

            .active {
                text-decoration: underline;
                color: ${theme.colors.base.accent};
            }

            .category:hover {
                color: ${theme.colors.base.accent};
                text-decoration: underline;
            }

            .inactive {
                cursor: pointer;
            }
        `}</style>
         {props.options.filter((option) => {
            return option.depth > 1;
         }).map((option, index) => {

            return (
                <div className={`category ${option.depth == 2 ? 'primary-category' : 'secondary-category'} ${option.status ? 'active' :''}`}>
                    <FormUnit margin={false} key={`option-${props.id}-${option.key}-${index}`}>
                        <div onClick={() => {
                            handleChange(props.id, option.key)
                        }} style={{marginLeft: (option.depth - 2) * 10 + 'px' }}>
                            {option.label}
                        </div>
                    </FormUnit>
                </div>
            )
        })}
    </>)
}

export default CategoryFilterBlock;
